import { buildURL } from "imgix-url-builder";
import { imageThumbnail } from "./isFilled.js";
const asImageSrc = (field, params = {}) => {
  if (field && imageThumbnail(field)) {
    return buildURL(field.url, params);
  } else {
    return null;
  }
};
export {
  asImageSrc
};
//# sourceMappingURL=asImageSrc.js.map
